import React from 'react'
import { getStatusColor, capitalize } from '../../lib/utils'
import { tx } from '../../lib/i18n'

interface StatusBadgeProps {
  status: string
  size?: 'sm' | 'md'
  label?: string
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'md', label }) => {
  const colorClass = getStatusColor(status)
  const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs font-medium'
  const displayLabel = label ?? tx(capitalize(status))

  return (
    <span
      className={`inline-flex items-center rounded-full border font-medium ${colorClass} ${sizeClass}`}
    >
      {displayLabel}
    </span>
  )
}

export default StatusBadge
